export const DOCUMENTS = {
  ROOT: '/documents',
};
